import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=92d99320&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=92d99320&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d99320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92d99320')) {
      api.createRecord('92d99320', component.options)
    } else {
      api.reload('92d99320', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=92d99320&scoped=true", function () {
      api.rerender('92d99320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/generateContract/detail.vue"
export default component.exports